import { SurveyPage } from "../../components/templates/SurveyPage";

const Survey = () => {
  return (
    <>
      <SurveyPage />
    </>
  );
};

export default Survey;
